import React from 'react';
import { Header } from '../../components/feature/Header';
import { Footer } from '../../components/feature/Footer';
import { HeroSection } from './components/HeroSection';
import { PromiseSection } from './components/PromiseSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { ProcessSection } from './components/ProcessSection';
import { AccommodationSection } from './components/AccommodationSection';
import { FAQSection } from './components/FAQSection';
import { ContactSection } from './components/ContactSection';
import SEOStructuredData from '../../components/feature/SEOStructuredData';

const HomePage: React.FC = () => {
  return (
    <>
      <SEOStructuredData type="FAQPage" />
      <div className="min-h-screen">
        <Header />
        <main>
          <HeroSection />
          <PromiseSection />
          <AboutSection />
          <ServicesSection />
          <ProcessSection />
          <AccommodationSection />
          <FAQSection />
          <ContactSection />
        </main>
        <Footer />
      </div>
    </>
  );
};

export default HomePage;